import { render, staticRenderFns } from "./VenderTopbar.vue?vue&type=template&id=2fbe34fc&scoped=true&"
import script from "./VenderTopbar.vue?vue&type=script&lang=js&"
export * from "./VenderTopbar.vue?vue&type=script&lang=js&"
import style0 from "./VenderTopbar.vue?vue&type=style&index=0&id=2fbe34fc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe34fc",
  null
  
)

export default component.exports